import axios from "@/utils/server";
import NewLive from "@/utils/NewLive";

//app登录
export const SetAppLogin = (params) => axios.post('/app/login', params)


export const openPrepay = (params) => NewLive.get(`/app/prepay/${params.propId}&${params.userId}&${params.activityId}&${params.total}`)



export const payNotify = (params) => axios.post('/app/pay-notify',params)





